import React, { Component } from "react";
import { connect } from "react-redux";
import NewModelFeatues from "./widgets/NewModelFeatues";
import ExplainFeaturesSvg from "./widgets/ExplainFeaturesSvg";
import BrandFeatures from "./widgets/BrandFeatures";
import StandardFeatures from "./widgets/StandardFeatures";
import DoeBanner from "./widgets/DoeBanner";
//import { changeRefrigerant } from "../stores/actions/compareModels";

class LoadNewModelUi extends Component {
  state = {
    selected_refrigerant: "R-448A",
    mesurement_system: "imperial",
    is_user_selected_refrigerant: false
  };
  fetchNomen = (nomenclature_name) => {
    for (var i = 0; i < this.props.compare.newmodel.nomenclature.length; i++) {
      if (
        this.props.compare.newmodel.nomenclature[i].name === nomenclature_name
      ) {
        return this.props.compare.newmodel.nomenclature[i];
      }
    }
    return null;
  };
  componentDidUpdate(prevProps) {
    if (this.props.autosuggest.value !== prevProps.autosuggest.value) {

        this.setState({selected_refrigerant: this.props.compare.newmodel?.refrigerents.length > 0 ? this.props.compare.newmodel.refrigerents[0] : "R-448A", is_user_selected_refrigerant: false});
    }
  }
  componentDidMount() {
    /*if (this.state.selected_refrigerant === "") {
      this.setState({
        selected_refrigerant: this.props.compare.newmodel.doe.refrigerents[0]
      });
    }*/
  }
  changeRefrigerant = (e) => {
    this.setState({ selected_refrigerant: e.target.value, is_user_selected_refrigerant: true });
  };
  render() {
    //To change selected refrigerant as per the model type
    if(this.props.compare.newmodel?.refrigerents.length > 0 && !this.state.is_user_selected_refrigerant) {
      if(this.props.compare.newmodel.refrigerents.includes("R-448A")){
        this.state.selected_refrigerant = "R-448A";
      }
      else{
        this.state.selected_refrigerant = this.props.compare.newmodel.refrigerents[0];
      }
    }
    // if (
    //   this.state.selected_refrigerant !== "R-448A" &&
    //   this.props.compare.newmodel.type === "PRO3"
    // ) {
    //   this.setState({ selected_refrigerant: "R-448A" });
    //   //alert("done");
    //   return <div></div>;
    // }
    
    if (this.props.compare.newmodel.status === "success") {
      let cat_groups = [];

      Object.keys(
        this.props.compare.newmodel.doe.refrigerants[
          this.state.selected_refrigerant
        ]
      ).forEach((key) => {
        cat_groups.push({
          key: key,
          value: this.props.compare.newmodel.doe.refrigerants[
            this.state.selected_refrigerant
          ][key],
        });
      });
      
      let sorted_cat_groups = [];

      let groups = [
        "General",
        "Efficiency",
        "Safety",
        "Dimensions",
        "Electrical Ratings",
        "Connections Data",
        "Other technical Data",
      ];



      for (var i = 0; i < groups.length; i++) {
        if (
          typeof this.props.compare.newmodel.doe.refrigerants[
            this.state.selected_refrigerant
          ][groups[i]] !== "undefined"
        ) {
          sorted_cat_groups.push({
            key: groups[i],
            value: this.props.compare.newmodel.doe.refrigerants[
              this.state.selected_refrigerant
            ][groups[i]],
          });
        } else {
          sorted_cat_groups.push({
            key: groups[i],
            value: {},
          });
        }
      }
      /*
      sorted_cat_groups.push({
        key: "Efficiency",
        value: this.props.compare.newmodel.doe.refrigerants[
          this.state.selected_refrigerant
        ]["Efficiency"]
      });
      sorted_cat_groups.push({
        key: "Safety",
        value: this.props.compare.newmodel.doe.refrigerants[
          this.state.selected_refrigerant
        ]["Safety"]
      });
      sorted_cat_groups.push({
        key: "Dimensions",
        value: this.props.compare.newmodel.doe.refrigerants[
          this.state.selected_refrigerant
        ]["Dimensions"]
      });
      sorted_cat_groups.push({
        key: "Other technical Data",
        value: this.props.compare.newmodel.doe.refrigerants[
          this.state.selected_refrigerant
        ]["Other technical Data"]
      });
*/
      let refrigerants = this.props.compare.newmodel.refrigerents;
      let selectable_ref = refrigerants.map((item) => {
        if (
          !isNaN(
            this.props.compare.newmodel.doe.refrigerants[item]["Efficiency"][
              "AWEF"
            ][this.state.mesurement_system]
          )
        ) {
          return item;
        }
      });
      var filtered_selectable_ref = selectable_ref.filter(function (el) {
        return el != null;
      });
     
// LUC family verbiage for Fan Diameter 30 condition
   var nochangelegacy = false;
   let nonochangelegacyMsg=false;
if(this.state.selected_refrigerant !== "R-454A" && this.state.selected_refrigerant !== "R-454C" && this.state.selected_refrigerant !== "R-455A"){
       if (this.props.compare.type === "LUC") {
          if (this.props.compare.doe.length > 0) {
          const fanDiameter = parseInt(
            this.props.compare.doe[0].refrigerants[
            this.state.selected_refrigerant
            ]["Electrical Ratings"]["Fan Diameter"]["imperial"].replace(",", "")
          );
          if (fanDiameter === 30) {
            nonochangelegacyMsg = true;
          }
          }   
     }  
     else{
         if (this.props.compare.type === "LUC" && this.props.compare.a2l.length > 0) {
              const fanDiameter = parseInt(
                this.props.compare.a2l[0].refrigerants[
                this.state.selected_refrigerant
                ]["Electrical Ratings"]["Fan Diameter"]["imperial"].replace(",", "")
              );
              if (fanDiameter === 30) {
                nonochangelegacyMsg = true;
              }
              }
          }
    }
      
      
      var measurment_unit = this.state.mesurement_system;
      let real_BTU = null;
      for(var b=0;b<sorted_cat_groups.length;b++){
        let item = sorted_cat_groups[b];
        if (item['key']=="Efficiency"){
          let hold_val = item['value'];
          if(hold_val['Application Capacity*'] != undefined){
           
            real_BTU = item['value']['Application Capacity*'][measurment_unit];
          }
        }
      }

      
     



      if (nochangelegacy) {
        return (
          <React.Fragment>
            <div className="Nav-area-final right">
              <div>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.print();
                  }}
                  className="btn print-btn"
                >
                  <i className="fa fa-print" aria-hidden="true" />
                  {"  Print"}
                </a>
              </div>
            </div>
            <DoeBanner
              selectable_ref={filtered_selectable_ref}
              type={this.props.compare.type}
              modelno={this.props.compare.newmodel.doe.modelno}
              selected_refrigerant={this.state.selected_refrigerant}
              refrigerant={refrigerants}
              onRefChange={this.changeRefrigerant}
              nochangelegacy={nochangelegacy}
              awef={
                this.props.compare.newmodel.doe.refrigerants[
                  this.state.selected_refrigerant
                ]["Efficiency"]["AWEF"][this.state.mesurement_system]
              }
            />

            <div className={"tab-wrapper-section "}>
              <div className="brand-differents-compare">
                <ul className="compare-list">
                  <li className="loadmodel-doe">
                    <label>New Model</label>
                    <div className="box-doe">
                      {this.props.compare.newmodel.doe.modelno}
                    </div>
                  </li>
                </ul>
              </div>
              <div className="brand-copare-list">
                {sorted_cat_groups.map((obj, index) => {
                  if (
                    typeof obj.value !== "undefined" &&
                    Object.entries(obj.value).length !== 0
                  ) {
                    return (
                      <NewModelFeatues
                        key={obj.key}
                        datas={obj.value}
                        title={obj.key}
                        mesurement_system={this.state.mesurement_system}
                      />
                    );
                  } else {
                    return <React.Fragment></React.Fragment>;
                  }
                })}
              </div>
            </div>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            <div className="Nav-area-final right">
              <div>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.print();
                  }}
                  className="btn print-btn"
                >
                  <i className="fa fa-print" aria-hidden="true" />
                  {"  Print"}
                </a>
              </div>
            </div>
            <DoeBanner
              selectable_ref={filtered_selectable_ref}
              type={this.props.compare.type}
              modelno={this.props.compare.newmodel.doe.modelno}
              selected_refrigerant={this.state.selected_refrigerant}
              refrigerant={refrigerants}
              onRefChange={this.changeRefrigerant}
              nochangelegacy={nochangelegacy}
              awef={
                this.props.compare.newmodel.doe.refrigerants[
                  this.state.selected_refrigerant
                ]["Efficiency"]["AWEF"][this.state.mesurement_system]
              }
            />

            <div className="new-model-ui">
              <div className="features-finish">
                <ExplainFeaturesSvg
                  type={this.props.compare.newmodel.type}
                  modelnumber={this.props.compare.newmodel.doe.modelno}
                  replace_btu={real_BTU}
                />
              </div>
              <BrandFeatures
                type={this.props.compare.newmodel.type}
                modelnumber={this.props.compare.newmodel.doe.modelno}
                replace_btu={real_BTU}
              />
              <StandardFeatures type={this.props.compare.newmodel.type} />
            </div>

            <div>
              <div className="cross_note">
                {this.props.compare.newmodel.type === "HTS" ? (
                  <ul className="awefnotes">
                    <li>
                      <h4>Notes</h4>
                    </li>
                    <li>
                      <span>*FSEC = Fixed Speed EC Motor</span>
                    </li>
                  </ul>
                ) : (
                  <ul className="awefnotes" />
                )}
              </div>
            </div>

            <div className={"tab-wrapper-section "}>
              <div className="brand-differents-compare">
                <ul className="compare-list">
                  <li className="loadmodel-doe">
                    <label>New Model</label>
                    <div className="box-doe">
                      {this.props.compare.newmodel.doe.modelno}
                    </div>
                  </li>
                </ul>
              </div>
              <div className="brand-copare-list">
                {sorted_cat_groups.map((obj, index) => {
                  if (
                    typeof obj.value !== "undefined" &&
                    Object.entries(obj.value).length !== 0
                  ) {
                    return (
                      <NewModelFeatues
                        key={obj.key}
                        datas={obj.value}
                        title={obj.key}
                        mesurement_system={this.state.mesurement_system}
                      />
                    );
                  } else {
                    return <React.Fragment></React.Fragment>;
                  }
                })}
              </div>
            </div>
          </React.Fragment>
        );
      }
    } else {
      return <React.Fragment></React.Fragment>;
    }
  }
}

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps)(LoadNewModelUi);
